import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../_services/app.service';

@Component({
  selector: 'app-repairs-and-maintenance',
  templateUrl: './repairs-and-maintenance.component.html',
  styleUrls: ['./repairs-and-maintenance.component.scss']
})
export class RepairsAndMaintenanceComponent implements OnInit {

  PostData: any = {};
  State: string = '';
  IssueNo: string = '';

  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private _activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      var UserId = this._activatedRoute.snapshot.queryParams["user"];
      var Status = this._activatedRoute.snapshot.queryParams["status"];
      this.IssueNo = this._activatedRoute.snapshot.queryParams["issueno"];
      this.State = Status;

      if (UserId !== undefined && UserId !== null && Status !== undefined && Status !== null
        && this.IssueNo !== undefined && this.IssueNo !== null) {
        this.UpdateMaintenanceStatus(UserId, Status, this.IssueNo);
      }
    });
  }

  UpdateMaintenanceStatus(UserId: any, Status: any, IssueNo: any) {

    this.PostData.UserId = UserId;
    this.PostData.Status = Status;
    this.PostData.IssueNo = IssueNo;

    this._appService.Post("Issue", "UpdateMaintenanceStatus", this.PostData).subscribe(response => {

      if (response[0].isDone == 'OK') {
        if (Status == 'Approved') {
          this.toastr.success("Successfully Approved !", 'Success');

          setTimeout(() => {
            window.close();
          }, 2000);
        } else {
          this.toastr.success("Successfully Rejected !", 'Success');

          setTimeout(() => {
            window.close();
          }, 2000);
        }
      }

    }, err => {
      this.toastr.error("Error occurred while saving data !", 'error');
    });
  }

}
